<div [class.verify-user-container]="!isDialogMode">
  <mat-card [class.horizinns-card]="!isDialogMode" [class.even-more-blur]="!isDialogMode" [class.verify-user-card]="!isDialogMode" [class.dialog-card]="isDialogMode">
    <mat-card-header>
      <img src="assets/images/logo_full_900.png" alt="Company Logo" class="logo" />
    </mat-card-header>
    <mat-card-content class="center">
      
      @switch (currentView) {
        
        @case ('loading') {
          <div class="loading center">
            <div class="margin-auto">
              <app-loader aria-label="Processing verification" class="gradient-spinner margin-auto"></app-loader>
              <p>Processing...</p>
            </div>
          </div>
        }

        @case ('verify-success') {
          <app-success-error [success]="true"></app-success-error>
          <h3>Email verified successfully!</h3>
          <p>You can now log in to your account.</p>
          <button type="button" mat-flat-button class="metallic-text-btn-blue" (click)="handleLoginRedirect()">Log In</button>
        }

        @case ('verify-failed') {
          <app-success-error [success]="false"></app-success-error>
          <h3>Verification failed</h3>
          <p>{{ errorMessage || 'The verification code may be invalid or expired.' }}</p>
          <ng-container *ngTemplateOutlet="codeEntryForm"></ng-container>
        }

        @case ('resend-success') {
          <app-success-error [success]="true"></app-success-error>
          <h3>Verification code resent</h3>
          <p>Please check your inbox (and spam/junk folder) for the new code.</p>
          <ng-container *ngTemplateOutlet="codeEntryForm"></ng-container>
        }

        @case ('resend-failed') {
          <app-success-error [success]="false"></app-success-error>
          <h3>Failed to resend code</h3>
          <p>{{ errorMessage || 'There was a problem sending the code. Please try again.' }}</p>
          <ng-container *ngTemplateOutlet="codeEntryForm"></ng-container>
        }

        @case ('initial') {
          <h3>
            Enter Verification Code
          </h3>
          <p>Please enter the 6-character code sent to your email.</p>
          <ng-container *ngTemplateOutlet="codeEntryForm"></ng-container>
        }
      }

    </mat-card-content>
  </mat-card>
</div>

<ng-template #codeEntryForm>
  <div class="center" style="margin-top: 20px;">
    <mat-form-field appearance="outline" style="width: 100%;">
      <mat-label>Email</mat-label>
      <input matInput [(ngModel)]="userEmail" type="email" placeholder="Enter your email" aria-label="Email input" />
    </mat-form-field>

    <mat-form-field appearance="outline" style="width: 100%;">
      <mat-label>Verification Code</mat-label>
      <input matInput [(ngModel)]="verificationCode" 
             autocomplete="one-time-code" 
             maxlength="6"
             placeholder="XXXXXX" 
             aria-label="Verification code input"
             style="text-transform: uppercase; font-family: 'Courier New', monospace; letter-spacing: 8px; font-size: 24px; text-align: center; font-weight: bold;" />
    </mat-form-field>
  </div>

  <div class="button-group" style="display: flex; flex-direction: row; gap: 12px; margin-top: 10px;">
    <button type="button" mat-flat-button class="metallic-text-btn" style="flex: 1;" (click)="resendVerification()" [disabled]="!userEmail">
      Resend Code
    </button>
    <button type="button" mat-flat-button class="metallic-text-btn-blue" style="flex: 1;" (click)="verifyEmail()" [disabled]="!userEmail || !verificationCode || verificationCode.length < 6">
      Verify Code
    </button>
  </div>
</ng-template>